import _ = require("underscore");
import ol = require("ol");
import Utils = require("../utils");
import Portal = require("portal-gis");
import Base = require("./base-command");

class Command extends Base<{}> {

    static about = `Logic to select the correct basemap.`;

    static options = {
        "allow-multi": {
            "about": `if "true", allows multiple basemaps to be visible at one time`,
        },
        "default-basemap": {
            "about": "Identifies the desired default basemap, if not provided the first visible basemap is assumed to be the default",
        },
    }

    static output = {
        "basemap": {
            "about": "A basemap configuration",
        },
    }

    private get basemaps() {
        let layers = this.mediator.config.Map.Layers.Layers.filter(l => !l.disabled);
        return layers.filter(l => l.basemap);
    }

    private show(id: string) {

        let basemap = this.basemaps.filter(b => b.id === id)[0];

        this.mediator.mapView(mapView => {
            // cannot set visibility without the underlying map
            this.mediator.mapViewMap(map => {

                this.basemaps.filter(b => b !== basemap).forEach(b => {
                    mapView.hideLayer(b.id);
                    Utils.setOption(b.Options.Values, { "visible": "false" });
                });

                if (basemap) {
                    Utils.setOption(basemap.Options.Values, { "visible": "true" });
                    mapView.showLayer(basemap.id);
                }

            });
        });

        return basemap;
    }

    execute(args = this.args) {

        let options = _.defaults(this.options, {
            "allow-multi": "false"
        });

        let doit = () => {
            // if no default basemap defined then pick the first visible basemap
            if (!options["default-basemap"]) {
                let visible = this.basemaps.filter(b => {
                    let o = Utils.asDictionary(b.Options.Values);
                    return o["visible"] !== "false";
                });
                if (visible.length) {
                    options["default-basemap"] = visible[0].id;
                    // TODO: how to prevent layers from rendering? Need to do this before the layers are merged
                    visible.shift();
                    visible.forEach(b => Utils.setOption(b.Options.Values, { "visible": "false" }));
                }
            }
        };

        Utils.ifOption(options, "allow-multi", v => v !== "true" && doit(), doit);

        Utils.ifOption(options, "default-basemap", v => {
            // show requires map, make sure it's set (could be a startup command)
            this.mediator.mapViewMap(map => {
                let basemap = this.show(v);
                this.trigger({ basemap: basemap });
            });
        });

    }

}

export = Command;